import { useCallback, useMemo } from 'react';
import { useFlexLayout, useTable } from 'react-table';

import { ReactTableWrapper } from 'ui-components/components/react-table-wrapper/react-table-wrapper';

import { useScanVerificationContext } from '../scan-verification-context-provider';
import { createActionsColumnDefinition } from './columns/actions';
import { createImageColumnDefinition } from './columns/image';
import { createItemNameColumnDefinition } from './columns/item-name';
import { createScannedColumnDefinition } from './columns/scanned';
import style from './styles.module.less';

export const ItemsToScanTable = () => {
  const columns = useMemo(
    () => [
      createItemNameColumnDefinition(),
      createImageColumnDefinition(),
      createScannedColumnDefinition(),
      createActionsColumnDefinition(),
    ],
    [],
  );

  const { items, isItemVerified, currentlyVerifyingItemId } = useScanVerificationContext();

  const getBodyRowClassName = useCallback(
    (row) => {
      const item = row.original;
      const isVerified = isItemVerified(item.fulfillmentPlanItemId);
      const isCurrentlyVerifying = currentlyVerifyingItemId === item.fulfillmentPlanItemId;

      if (isCurrentlyVerifying) {
        return style['verifying-row'];
      }

      return isVerified ? style['verified-row'] : '';
    },
    [isItemVerified, currentlyVerifyingItemId],
  );

  const { getTableProps, headerGroups, getTableBodyProps, rows, prepareRow } = useTable(
    {
      columns,
      data: items,
    },
    useFlexLayout,
  );

  return (
    <ReactTableWrapper
      className={style['table-container']}
      getBodyRowClassName={getBodyRowClassName}
      getTableBodyProps={getTableBodyProps}
      getTableProps={getTableProps}
      headerGroups={headerGroups}
      headerRowClassName={style['header-row']}
      prepareRow={prepareRow}
      rows={rows}
    />
  );
};
